import {Component, EventEmitter, Input, Optional, Output} from '@angular/core';
import {FormGroup} from "@angular/forms";
import {FormlyFieldConfig, FormlyFormOptions} from "@ngx-formly/core";
import {NbWindowRef} from "@nebular/theme";

@Component({
  selector: 'app-dam-item-params',
  templateUrl: './dam-item-params.component.html',
})
export class DamItemParamsComponent {
  constructor(
    @Optional() protected readonly windowRef: NbWindowRef,
  ) {
  }

  @Input() form: FormGroup
  @Input() fields: FormlyFieldConfig[]
  @Input() options: FormlyFormOptions
  @Input() isModal: boolean
  @Input() showListButton: boolean
  @Input() model: any
  @Input() absolutePath: any

  @Output() submitEvent = new EventEmitter

  onSubmit() {
    this.submitEvent.emit()
  }

  modalClose(): void {
    this.windowRef.close();
  }
}
